/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSquareLetterW = createReactComponent("outline", "square-letter-w", "IconSquareLetterW", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M9 8l1 8l2 -5l2 5l1 -8", "key": "svg-1" }]]);

export { IconSquareLetterW as default };
//# sourceMappingURL=IconSquareLetterW.mjs.map
